module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('h2', {
    staticClass: "c2",
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("CHAPTER II"), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    staticClass: "c10"
  }, [_vm._v("THE FAIRY TALE AND THE TRUE STORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre drop-capa0_2_0_"
  }, [_vm._v("THE six of them were gathered together. Uncle Paul was reading in a big book, Jacques braiding a wicker basket, Mother Ambroisine plying her distaff, Claire marking linen with red thread, Emile and Jules playing with the Noah’s Ark. And when they had lined up the horse after the camel, the dog after the horse, then the sheep, donkey, ox, lion, elephant, bear, gazelle, and a great many others,—when they had them all arranged in a long procession leading to the ark, Emile and Jules, tired of playing, said to Mother Ambroisine: “Tell us a story, Mother Ambroisine—one that will amuse us.”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("And with the simplicity of old age Mother Ambroisine spoke as follows, at the same time twirling her spindle:")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Once upon a time a grasshopper went to the fair with an ant. The river was all frozen. Then the grasshopper gave a jump and landed on the other side of the ice, but the ant could not do this; and it said to the grasshopper: ‘Take me on your shoulders; I weigh so little.’ But the grasshopper said: ‘Do as I do; give a spring, and jump.’ The ant gave a spring, but slipped and broke its leg.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Ice, ice, the strong should be kind; but you are wicked, to have broken the ant’s leg—poor little leg.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Then the ice said: ‘The sun is stronger than I, and it melts me.’")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Sun, sun, the strong should be kind; but you are wicked, to melt the ice; and you, ice, to have broken the ant’s leg—poor little leg.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Then the sun said: ‘The clouds are stronger than I; they hide me.’")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Clouds, clouds, the strong should be kind; but you are wicked, to hide the sun; you, sun, to melt the ice; and you, ice, to have broken the ant’s leg—poor little leg.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Then the clouds said: ‘The wind is stronger than we; it drives us away.’")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Wind, wind, the strong should be kind; but you are wicked, to drive away the clouds; you, clouds, to hide the sun; you, sun, to melt the ice; and you, ice, to have broken the ant’s leg—poor little leg.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Then the wind said: ‘The walls are stronger than I; they stop me.’")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Walls, walls, the strong should be kind; but you are wicked, to stop the wind; you, wind, to drive away the clouds; you, clouds, to hide the sun; you, sun, to melt the ice; and you, ice, to have broken the ant’s leg—poor little leg.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Then the walls said: ‘The rat is stronger than we; it bores holes through us.’")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Rat, rat, the strong—”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“But it is all the same thing, over and over again, Mother Ambroisine,” exclaimed Jules impatiently.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Not quite, my child. After the rat comes the cat that eats the rat, then the broom that strikes the cat, then the fire that burns the broom, then the water that puts out the fire, then the ox that quenches his thirst with the water, then the fly that stings the ox, then the swallow that snaps up the fly, then the snare that catches the swallow, then—”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“And does it go on very long like that?” asked Emile.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“As long as you please,” replied Mother Ambroisine, “for however strong one may be, there are always others stronger still.”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Really, Mother Ambroisine,” said Emile, “that story tires me.”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“Then listen to this one: Once upon a time there lived a woodchopper and his wife, and they were very poor. They had seven children, the youngest so very, very small that a wooden shoe answered for its bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“I know that story,” again interposed Emile. “The seven children are going to get lost in the woods. Little Hop-o’-my-Thumb marks the way at first with white pebbles, then with bread crumbs. Birds eat the crumbs. The children get lost, Hop-o’-my-Thumb, from the top of a tree, sees a light in the distance. They run to it: rat-tat-tat! It is the dwelling of an ogre!”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“There is no truth in that,” declared Jules, “nor in Puss-in-Boots, nor Cinderella, nor Bluebeard. They are fairy tales, not true stories. For my part, I want stories that are really and truly so.”")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("At the words, true stories, Uncle Paul raised his head and closed his big book. A fine opportunity offered for turning the conversation to more useful and interesting subjects than Mother Ambroisine’s old tales.")]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“I approve of your wanting true stories,” said he. “You will find in them at the same time the marvelous, which pleases so much at your age, and also the useful, with which even at your age you must concern yourselves, in preparation for after life. Believe me, a true story is much more interesting than a tale in which ogres smell fresh blood and fairies change pumpkins into carriages and lizards into lackeys. And could it be otherwise? Compared with truth, fiction is but a pitiful trifle; for the former is the work of God, the latter the dream of man. Mother Ambroisine could not interest you with the ant that broke its leg in trying to cross the ice. Shall I be more fortunate? Who wants to hear a true story of real ants?”")]), _vm._v(" "), _c('div', {
    staticClass: "figcenter2"
  }, [_c('img', {
    staticClass: "ig",
    attrs: {
      "alt": "",
      "src": "Images/img0001.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ic"
  }, [_c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("White Ant")])])])]), _vm._v(" "), _c('p', {
    staticClass: "c9"
  }, [_vm._v("“I! I!” cried Emile, Jules, and Claire all together.")]), _vm._v(" "), _c('div', {
    staticClass: "pbb",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_c('hr', {
    staticClass: "pb"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4173c1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0